export default __webpack_public_path__ + "static/media/podcastsretro.f8946c47.png";